var map = {
	"./topic_문화예술.png": "4/c+",
	"./topic_생태/자원.png": "NXKi",
	"./topic_역사.png": "jS1l",
	"./topic_인물.png": "7umw",
	"./topic_지리/영토.png": "haxK",
	"./topic_침탈.png": "kgSm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MO/P";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/topic_.*\.png$
// module id = MO/P
// module chunks = 0